export function isEmpty(value: string) {

  return !value || value.trim() === '';
}